import { Headphones, Mic } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { Image } from "@/components/image";
import { houseLogo, houseName } from "@/lib/contributor-profile";
import type { OnAirPerson } from "@/lib/episodes";
import { cn } from "@/lib/utils";

function HouseCrest({ house }: { house: string | null }) {
  const logo = houseLogo(house);
  if (!logo) {
    return null;
  }
  return (
    <Image
      alt=""
      className="size-4 shrink-0 object-contain"
      height={16}
      src={logo}
      width={16}
    />
  );
}

function PeopleGroup({
  icon: Icon,
  label,
  people,
}: {
  icon: LucideIcon;
  label: string;
  people: OnAirPerson[];
}) {
  if (people.length === 0) {
    return null;
  }
  return (
    <span className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
      <Icon aria-hidden className="size-3.5 shrink-0 opacity-70" />
      <span className="sr-only">{label}:</span>
      {people.map((person) => (
        <span className="inline-flex items-center gap-1" key={person.id}>
          <HouseCrest house={person.house} />
          {person.firstName}
          {person.house && (
            <span className="sr-only"> ({houseName(person.house)})</span>
          )}
        </span>
      ))}
    </span>
  );
}

export function LineUp({
  className,
  hosts,
  techies,
}: {
  className?: string;
  hosts: OnAirPerson[];
  techies: OnAirPerson[];
}) {
  if (hosts.length === 0 && techies.length === 0) {
    return null;
  }
  return (
    <span
      className={cn(
        "mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm",
        className
      )}
    >
      <PeopleGroup icon={Mic} label="Hosts" people={hosts} />
      <PeopleGroup icon={Headphones} label="Tech" people={techies} />
    </span>
  );
}
